var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "5" } }, [
                        _vm._v("Select Template:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-left", attrs: { cols: "7" } },
                        [
                          _c("b-form-select", {
                            staticClass: "modelSelect",
                            attrs: {
                              plain: true,
                              options: _vm.availableTemplateDocs,
                              placeholder: "Select Template"
                            },
                            on: { change: _vm.fetchTemplates }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "5" } }, [
                        _vm._v("Select Page:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-left", attrs: { cols: "7" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.templateOptions
                            },
                            model: {
                              value: _vm.selectedTemplate.template,
                              callback: function($$v) {
                                _vm.$set(_vm.selectedTemplate, "template", $$v)
                              },
                              expression: "selectedTemplate.template"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "5" } }, [
                        _vm._v("Config Type:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-left", attrs: { cols: "7" } },
                        [
                          _c("b-form-select", {
                            attrs: { plain: true, options: _vm.configTypes },
                            model: {
                              value: _vm.selectedTemplate.configType,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selectedTemplate,
                                  "configType",
                                  $$v
                                )
                              },
                              expression: "selectedTemplate.configType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "b-button",
            {
              staticClass: "button-style",
              attrs: {
                type: "button",
                variant: "primary",
                disabled:
                  !_vm.selectedTemplate.template ||
                  !_vm.selectedTemplate.configType
              },
              on: { click: _vm.compareConfig }
            },
            [_vm._v(" Compare ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "button-style",
              attrs: { type: "button", variant: "secondary" },
              on: { click: _vm.updateConfigs }
            },
            [_vm._v(" Update ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "comparison-modal",
          attrs: {
            title: "Configuration Comparison Results",
            size: "xl",
            "ok-only": "",
            "hide-footer": ""
          },
          model: {
            value: _vm.showComparisonModal,
            callback: function($$v) {
              _vm.showComparisonModal = $$v
            },
            expression: "showComparisonModal"
          }
        },
        [
          _vm.comparisonResult
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "diff-summary" }, [
                    _c(
                      "div",
                      [
                        _vm.getPendingRemovals() > 0
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "mr-2",
                                attrs: { variant: "danger" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.getPendingRemovals()) +
                                    " removal" +
                                    _vm._s(
                                      _vm.getPendingRemovals() !== 1 ? "s" : ""
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getPendingAdditions() > 0
                          ? _c("b-badge", { attrs: { variant: "success" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getPendingAdditions()) +
                                  " addition" +
                                  _vm._s(
                                    _vm.getPendingAdditions() !== 1 ? "s" : ""
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getModifiedCount() > 0
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "mr-2",
                                attrs: { variant: "info" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.getModifiedCount()) +
                                    " modification" +
                                    _vm._s(
                                      _vm.getModifiedCount() !== 1 ? "s" : ""
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "diff-stats" },
                      [
                        _c("span", { staticClass: "lines-count" }, [
                          _vm._v(_vm._s(_vm.getTotalLines()) + " lines")
                        ]),
                        _vm._v(" "),
                        _vm.getRejectedFieldsCount() > 0
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "ml-3",
                                attrs: { variant: "warning" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.getRejectedFieldsCount()) +
                                    " field" +
                                    _vm._s(
                                      _vm.getRejectedFieldsCount() !== 1
                                        ? "s"
                                        : ""
                                    ) +
                                    " reverted\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.comparisonResult.identical
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { variant: "success", show: "" }
                        },
                        [
                          _c("strong", [_vm._v("✓ No Differences Found!")]),
                          _vm._v(
                            " The stored file matches the existing configuration.\n      "
                          )
                        ]
                      )
                    : _c("div", { staticClass: "diff-container" }, [
                        _c("div", { staticClass: "diff-header" }, [
                          _c("div", { staticClass: "diff-column" }, [
                            _c(
                              "span",
                              { staticClass: "diff-title removed-title" },
                              [_vm._v("Current Configuration")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "diff-column" }, [
                            _c(
                              "span",
                              { staticClass: "diff-title added-title" },
                              [_vm._v("Updated Configuration")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "diff-content" },
                          _vm._l(_vm.formattedDiff, function(line, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "diff-line-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "diff-line",
                                    class: [
                                      line.type,
                                      {
                                        "field-reverted": _vm.isFieldReverted(
                                          line.fieldId
                                        )
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "diff-column left-column"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "line-number",
                                            class: { "empty-line": !line.left }
                                          },
                                          [_vm._v(_vm._s(line.leftNumber))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "pre",
                                          {
                                            staticClass: "line-content",
                                            class: {
                                              "highlight-removed":
                                                line.hasChange &&
                                                line.fieldId &&
                                                line.type === "modified"
                                            }
                                          },
                                          [_vm._v(_vm._s(line.left))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "diff-column right-column"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "line-number-container"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "line-number",
                                                class: {
                                                  "empty-line": !line.right
                                                }
                                              },
                                              [_vm._v(_vm._s(line.rightNumber))]
                                            ),
                                            _vm._v(" "),
                                            line.hasChange && line.fieldId
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "action-buttons"
                                                  },
                                                  [
                                                    !_vm.isFieldReverted(
                                                      line.fieldId
                                                    )
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "b-tooltip",
                                                                rawName:
                                                                  "v-b-tooltip.hover",
                                                                modifiers: {
                                                                  hover: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "reject-btn",
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-danger",
                                                              title:
                                                                "Revert this field to current value"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.rejectField(
                                                                  line.fieldId
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-times"
                                                            })
                                                          ]
                                                        )
                                                      : _c(
                                                          "b-button",
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "b-tooltip",
                                                                rawName:
                                                                  "v-b-tooltip.hover",
                                                                modifiers: {
                                                                  hover: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "accept-btn",
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-success",
                                                              title:
                                                                "Accept the updated value"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.acceptField(
                                                                  line.fieldId
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-check"
                                                            })
                                                          ]
                                                        )
                                                  ],
                                                  1
                                                )
                                              : line.hasChange &&
                                                !line.fieldId &&
                                                line.changeId
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "action-buttons"
                                                    },
                                                    [
                                                      !_vm.isChangeRejected(
                                                        line.changeId
                                                      )
                                                        ? _c(
                                                            "b-button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover",
                                                                  modifiers: {
                                                                    hover: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "reject-btn",
                                                              attrs: {
                                                                size: "sm",
                                                                variant:
                                                                  "outline-danger",
                                                                title:
                                                                  "Reject this change"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.rejectChange(
                                                                    line.changeId
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-times"
                                                              })
                                                            ]
                                                          )
                                                        : _c(
                                                            "b-button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover",
                                                                  modifiers: {
                                                                    hover: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "accept-btn",
                                                              attrs: {
                                                                size: "sm",
                                                                variant:
                                                                  "outline-success",
                                                                title:
                                                                  "Accept this change"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.acceptChange(
                                                                    line.changeId
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-check"
                                                              })
                                                            ]
                                                          )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "pre",
                                          {
                                            staticClass: "line-content",
                                            class: _vm.getLineContentClass(line)
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.getDisplayValue(line))
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          })
                        )
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer-actions mt-3" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "outline-secondary" },
                          on: { click: _vm.resetAllChanges }
                        },
                        [_vm._v("Reset All")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "secondary" },
                          on: { click: _vm.updateConfigs }
                        },
                        [_vm._v("Update")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ee07d03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee07d03","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/templateConfigBulkUpdate.vue
// module id = 1410
// module chunks = 2